import styles from './Solution.module.scss'

type Props = {
  contents: {
    firstLine: {
      text: string
      color: string
    }[]
    secondLine: {
      text: string
      color: string
    }[]
    description: string[]
    list: {
      text: string
      icon: string
    }[]
  }
}

export const Solution: React.FC<Props> = ({ contents }) => {
  return (
    <div className={styles.solution_container}>
      <div className={styles.triangle}></div>
      <div className={styles.main_container}>
        <div className={styles.text_container}>
          <div className={styles.title_container}>
            <div className={styles.title_line}>
              {contents.firstLine.map((title) => (
                <p key={title.text} className={styles.first_line} style={{ color: title.color }}>
                  {title.text}
                </p>
              ))}
            </div>
            <div className={styles.title_line}>
              {contents.secondLine.map((title) => (
                <p key={title.text} className={styles.second_line} style={{ color: title.color }}>
                  {title.text}
                </p>
              ))}
            </div>
          </div>
          <div className={styles.description_container}>
            {contents.description.map((description) => (
              <p key={description} className={styles.description}>
                {description}
              </p>
            ))}
          </div>
        </div>
        <div className={styles.list}>
          {contents.list.map((item) => (
            <div key={item.icon} className={styles.list_item}>
              <div className={styles.icon_container}>
                <img src={item.icon} alt="" className={styles.icon} />
              </div>
              <p className={styles.text}>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
